<template>
  <el-dialog
    class="dialog-container dialog-height"
    :title="title"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    destroy-on-close
  >
    <el-form ref="form" :model="form" :rules="formRules" label-width="155px">
      <!-- 基本信息 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>基本信息</span>
        </div>
        <!-- 车型 -->
        <el-form-item label="车型" prop="carModel">
          <el-input v-model="form.carModel" placeholder="请输入车型" />
        </el-form-item>
        <!-- 车辆属性 -->
        <el-form-item label="车辆属性" prop="carAttribute">
          <el-select
            filterable
            clearable
            v-model="form.carAttribute"
            placeholder="请选择车辆属性"
          >
            <el-option label="燃油车" :value="0"> </el-option>
            <el-option label="电动车" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障发生日期 -->
        <el-form-item label="故障发生日期" prop="happenDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.happenDate"
            placeholder="请选择故障发生日期"
          ></el-date-picker>
        </el-form-item>
        <!-- 故障发生地点 -->
        <el-form-item label="故障发生地点" prop="happenPlace">
          <el-input
            v-model="form.happenPlace"
            maxlength="200"
            placeholder="请输入故障发生地点"
          ></el-input>
        </el-form-item>
        <!-- 报修日期 -->
        <el-form-item label="报修日期" prop="repairDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.repairDate"
            placeholder="请选择报修日期"
          />
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item label="严重程度" prop="severityLevel">
          <el-select
            filterable
            clearable
            v-model="form.severityLevel"
            placeholder="请选择严重程度"
          >
            <el-option
              v-for="(item, index) in severityData"
              :key="index"
              :label="item.label"
              :value="item.code"
            >
              <el-tooltip placement="right" effect="light">
                <div
                  slot="content"
                  class="severityTips"
                  v-html="item.desc"
                ></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 客户诉求 -->
        <el-form-item label="客户诉求" prop="customerDemand">
          <el-input
            v-model="form.customerDemand"
            type="textarea"
            placeholder="请输入客户诉求"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 是否重点问题 -->
        <el-form-item label="是否重点问题" prop="importantType" required>
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item
          v-if="form.importantType === 1"
          label="重点问题描述"
          prop="importantDescribe"
        >
          <el-input
            v-model="form.importantDescribe"
            placeholder="请输入重点问题描述"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item label="是否有维修措施" prop="serviceMeasure" required>
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 市场维修措施 -->
        <el-form-item
          label="市场维修措施"
          prop="marketService"
          v-if="form.serviceMeasure == 1"
        >
          <el-input
            v-model="form.marketService"
            type="textarea"
            placeholder="请输入故障现象描述"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 生产订单号 -->
        <el-form-item label="生产订单号" prop="orderNum">
          <el-input v-model="form.orderNum" placeholder="请输入生产订单号" />
        </el-form-item>
        <!-- 订单车辆数量 -->
        <el-form-item label="订单车辆数量" prop="carTotal">
          <el-input-number
            class="number-input"
            placeholder="请输入订单车辆数量"
            :controls="false"
            :precision="0"
            v-model="form.carTotal"
          >
          </el-input-number>
          <div class="number-input-append">台</div>
        </el-form-item>
        <!-- 故障车数量 -->
        <el-form-item label="故障车数量" prop="badCarTotal">
          <el-input-number
            disabled
            class="number-input"
            placeholder="请输入故障车数量"
            :controls="false"
            :precision="0"
            v-model="form.badCarTotal"
          >
          </el-input-number>
          <div class="number-input-append">台</div>
        </el-form-item>
        <!-- 故障车VIN码 -->
        <div>
          <el-form-item label="故障车VIN码" prop="vinCheckRespList">
            <!-- 表格内容 -->
            <div class="table-container">
              <div style="margin-bottom: 15px">
                <!-- 添加 -->
                <el-button
                  class="primary-btn"
                  type="primary"
                  icon="el-icon-plus"
                  size="small"
                  @click="handleAdd"
                  >添加</el-button
                >
                <!-- 批量导入 -->
                <el-button
                  class="primary-btn"
                  plain
                  icon="el-icon-upload2"
                  type="primary"
                  size="small"
                  @click="handleImport"
                  >批量导入</el-button
                >
              </div>
              <el-table
                ref="tableRef"
                stripe
                border
                highlight-current-row
                :data="form.vinCheckRespList"
                :cell-class-name="getRowColumn"
                @cell-click="tabClick"
                max-height="450px"
              >
                <!-- VIN码 -->
                <el-table-column
                  property="vin"
                  label="VIN码"
                  min-width="180px"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      ref="inputRef"
                      id="inputRef"
                      v-model="scope.row.vin"
                      placeholder="请输入VIN码"
                      clearable
                      @blur="inputBlur"
                      @change="handleInput"
                    />
                  </template>
                </el-table-column>
                <!-- 订单号 -->
                <el-table-column
                  property="orderNum"
                  label="订单号"
                  min-width="120px"
                  show-overflow-tooltip
                  align="center"
                >
                  <!-- <template slot="header">
                    <span style="color: #f56c6c"> * </span>订单号
                  </template> -->
                  <template slot-scope="scope">
                    <!-- <el-form-item
                      :prop="`vinCheckRespList[${scope.$index}].orderNum`"
                    > -->
                    <el-input
                      @blur="orderInputBlur"
                      v-model="scope.row.orderNum"
                      placeholder="请输入订单号"
                    />
                    <!-- </el-form-item> -->
                  </template>
                </el-table-column>
                <!-- 信息 -->
                <el-table-column
                  label="信息"
                  min-width="120px"
                  show-overflow-tooltip
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      :style="
                        scope.row.messageZh === '成功'
                          ? 'color:#0EC98E'
                          : 'color:#ff0000'
                      "
                    >
                      {{ scope.row.messageZh }}
                    </span>
                  </template>
                </el-table-column>
                <!-- 生产日期 -->
                <el-table-column
                  label="生产日期"
                  align="center"
                  width="160px"
                  property="vinCreated"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      type="date"
                      value-format="yyyy-MM-dd"
                      v-model="scope.row.vinCreated"
                      placeholder="请选择生产日期"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作" align="center" width="90px">
                  <template slot-scope="scope">
                    <!-- 删除 -->
                    <el-button
                      size="mini"
                      type="text"
                      @click="handleDelete(scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </div>
        <!-- 零部件类别 -->
        <el-form-item label="零部件类别" prop="componentCategory">
          <el-select
            v-model="form.componentCategory"
            filterable
            clearable
            placeholder="请选择零部件类别"
          >
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get('zh')]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 零部件批次信息 -->
        <el-form-item label="零部件批次信息" prop="componentBatchs">
          <el-input
            v-model="form.componentBatchs"
            placeholder="请输入零部件批次信息"
          />
        </el-form-item>
        <!-- 发动机型号 -->
        <el-form-item
          label="发动机型号"
          prop="engineModel"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineModel"
            placeholder="请输入发动机型号"
          ></el-input>
        </el-form-item>
        <!-- 发动机号 -->
        <el-form-item
          label="发动机号"
          prop="engineNumber"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineNumber"
            placeholder="请输入发动机号"
          ></el-input>
        </el-form-item>
        <!-- 动力电池号 -->
        <el-form-item
          label="动力电池号"
          prop="batteryNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.batteryNumber"
            placeholder="请输入动力电池号"
          ></el-input>
        </el-form-item>
        <!-- 电机号 -->
        <el-form-item
          label="电机号"
          prop="motorNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.motorNumber"
            placeholder="请输入电机号"
          ></el-input>
        </el-form-item>
        <!-- 故障数量 -->
        <el-form-item label="故障数量" prop="faultNumber">
          <el-input-number
            :controls="false"
            :precision="0"
            v-model="form.faultNumber"
            placeholder="请输入故障数量"
          >
          </el-input-number>
        </el-form-item>
        <!-- 疑似/祸首件代码 -->
        <el-form-item label="疑似/祸首件代码" prop="suspectPartNumber">
          <div class="searchFlex">
            <el-input
              v-model="form.suspectPartNumber"
              placeholder="请输入疑似/祸首件代码"
            ></el-input>
            <el-button
              class="primary-btn"
              type="primary"
              @click="handlePartSearch"
              >查询</el-button
            >
          </div>
        </el-form-item>
        <!-- 疑似/祸首件名称 -->
        <el-form-item label="疑似/祸首件名称" prop="suspectPartName">
          <el-input
            v-model="form.suspectPartName"
            placeholder="请输入疑似/祸首件名称"
          ></el-input>
        </el-form-item>
        <!-- 供应商代码/名称 -->
        <!-- <el-form-item label="疑似/祸首件代码" prop="supplierInfo">
          <el-input v-model="form.supplierInfo" placeholder="请输入疑似/祸首件代码"></el-input>
        </el-form-item> -->
      </div>
      <!-- 问题描述 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/wtmsIcon.png" alt="" />
          问题描述
        </div>

        <!-- 故障描述 -->
        <el-form-item label="故障现象描述" prop="questionContent">
          <el-input
            v-model="form.questionContent"
            type="textarea"
            placeholder="请输入故障现象描述"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 重复性 -->
        <el-form-item label="重复性" prop="repeatability">
          <el-radio-group v-model="form.repeatability">
            <el-radio :label="0">一直存在</el-radio>
            <el-radio :label="1">偶发 </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 附件 -->
        <!-- <el-form-item label="附件" prop="faultCommonFiles">
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCommonFiles"
            :httpRequest="action"
          />
        </el-form-item> -->
      </div>
      <!-- 图片和视频 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/ImgIcon.png" alt="" />
          图片和视频
        </div>
        <fileUploadTips></fileUploadTips>
        <!-- 是否有故障视频/图片 -->
        <el-form-item label="是否有故障视频/图片" prop="faultVideo" required>
          <el-radio-group v-model="form.faultVideo">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="附件"
          prop="faultVideoFiles"
          v-if="form.faultVideo == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultVideoFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有故障代码 -->
        <el-form-item label="是否有故障代码" prop="faultCode" required>
          <el-radio-group v-model="form.faultCode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="faultCodeRemark"
          v-if="form.faultCode == 1"
        >
          <el-input
            v-model="form.faultCodeRemark"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="附件"
          prop="faultCodeFiles"
          v-if="form.faultCode == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCodeFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有其他说明 -->
        <el-form-item label="是否有其他说明" prop="otherInstructions" required>
          <el-radio-group v-model="form.otherInstructions">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="otherRemark"
          v-if="form.otherInstructions == 1"
        >
          <el-input
            v-model="form.otherRemark"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="附件"
          prop="otherFiles"
          v-if="form.otherInstructions == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.otherFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer-button">
      <!-- <el-button
        :disabled="
          form.vinCheckRespList.findIndex((item) => {
            return (
              item.messageZh === 'Vin码与车型不符合,请核对后填写' ||
              item.messageZh === 'Vin码不存在,请核对后填写' ||
              !item.messageZh
            );
          }) !== -1
        "
        type="primary"
        @click="handleSave"
        class="lang-but"
      >
        提交
      </el-button> -->
      <el-button type="primary" @click="handleSave" class="lang-but">
        提交
      </el-button>
      <el-button
        type="primary"
        class="lang-but"
        plain
        @click="dialogVisible = false"
        >取消</el-button
      >
    </div>
    <import-model-dialog
      ref="importModelDialog"
      :uploadUrl="uploadUrl"
      templateUrl="https://shineray-dev-oversea.oss-cn-chengdu.aliyuncs.com/dev/excel/claim-excel/2024/10/23/4f53bcea6a4a42849f9033fa94b37c7e.xlsx"
      @success="getList"
    />
  </el-dialog>
</template>

<script>
import {
  preProblemAddApi,
  preProblemEditApi,
  checkModelApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import { getECPDataByVIN } from "@/api/seek";
import ImportModelDialog from "@/components/importModelDialog.vue";
import componentConfig from "@/mixins/componentConfig";
import { uploadUrl } from "@/util/url";
import CryptoJS from "crypto-js";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
import { getStorage } from "@/util/localStor";
export default {
  components: { ImportModelDialog, fileUploadTips },
  mixins: [componentConfig],
  props: {
    carTypeList: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      action: "/manage/saleChannelController/upload/file",
      modalVin: "", // 带出车型的vin
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      tabRowIndex: "", // 点击表格行索引
      tabColumnIndex: "", // 点击表格列索引
      uploadUrl: uploadUrl + "/manage/car/feedback/question/importVin", // 导入地址
    };
  },
  // watch: {
  //   "form.vinCheckRespList": {
  //     deep: true,
  //     handler(val) {
  //       this.form.orderNum = [
  //         ...new Set(val.map((item) => item.orderNum)),
  //       ].join(",");
  //       this.form.badCarTotal = val.length;
  //     },
  //   },
  //   "form.orderNum": {
  //     handler(val) {
  //       if (val) this.handleOrder();
  //     },
  //   },
  // },
  computed: {
    // 表单验证规则
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        carModel: createRule("车型"),
        carAttribute: createRule("车辆属性"),
        happenDate: createRule("故障发生日期"),
        repairDate: createRule("报修日期"),
        severityLevel: createRule("严重程度"),
        importantDescribe: createRule("重点问题描述"),
        marketService: createRule("市场维修措施"),
        orderNum: createRule("生产订单号"),
        carTotal: createRule("订单车辆数量"),
        vinCheckRespList: createRule("故障车VIN码"),
        componentCategory: createRule("零部件类别"),
        engineModel: createRule("发动机型号"),
        engineNumber: createRule("发动机号"),
        faultNumber: createRule("故障数量"),
        customerDemand: createRule("客户诉求"),
        questionContent: createRule("故障现象描述"),
        repeatability: createRule("重复性"),
        faultVideoFiles: createRule("是否有故障视频/图片附件"),
        faultCodeRemark: createRule("是否有故障代码备注"),
        otherRemark: createRule("是否有其他说明备注"),
      };
    },
  },
  created() {},
  methods: {
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      //拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    // 初始化
    async init(title, data = {}, qualityData) {
      this.title = title;
      this.dialogVisible = true;
      this.form = this.getForm(data, qualityData);
      this.form.vinCheckRespList.map((item, index) => {
        this.form.vinCheckRespList[index].messageZh = "成功";
      });
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },

    getFileInfo(fileItem) {
      const value = fileItem;
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        try {
          return JSON.parse(value) || [];
        } catch {
          return [];
        }
      }
      // 其他情况（undefined/null）→ 返回空数组
      return [];
    },
    // 获取表单对象
    getForm(data = {}, qualityData = {}) {
      const customer = getStorage("qualityData");
      return {
        // customerId: qualityData.customerId || customer.customerId,
        // customerName: qualityData.customerName || customer.customerName,
        countryDataId: data.countryDataId || customer.countryDataId,
        carType: data.carType || customer.carType,
        // customerCountry:
        // qualityData.customerCountry || customer.customerCountry,
        // customerAccountNum:
        // qualityData.customerAccountNum || customer.customerAccountNum,
        carModel: data.carModel || "",
        carAttribute: data.carAttribute,
        happenDate: data.happenDate || "",
        happenPlace: data.happenPlace || "",
        repairDate: data.repairDate || "",
        severityLevel: data.severityLevel || "",
        importantType: data.importantType ?? 1,
        importantDescribe: data.importantDescribe || "",
        serviceMeasure: data.serviceMeasure ?? 1,
        marketService: data.marketService || "",
        nowTaskId: data.nowTaskId || "",
        orderNum: data.orderNum || "",
        carTotal: data.carTotal || undefined,
        badCarTotal: data.badCarTotal || undefined,
        vinCheckRespList: data.vinCheckRespList
          ? JSON.parse(JSON.stringify(data.vinCheckRespList))
          : [],
        componentCategory: Number(data.componentCategory) || "",
        componentBatchs: data.componentBatchs || "",
        engineModel: data.engineModel || "",
        engineNumber: data.engineNumber || "",
        batteryNumber: data.batteryNumber || "",
        motorNumber: data.motorNumber || "",
        faultNumber: data.faultNumber || undefined,
        suspectPartName: data.suspectPartName || "",
        suspectPartNumber: data.suspectPartNumber || "",
        customerDemand: data.customerDemand || "",
        supplierInfo: data.supplierInfo || "",
        questionContent: data.questionContent || "",
        repeatability: data.repeatability || 0,
        faultCommonFiles: this.getFileInfo(data.faultCommonFiles),

        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",

        delList: [], // 删除vin列表记录
        // faultPartName: data.faultPartName || "",
        // faultPartNumber: data.faultPartNumber || "",
        orderNumber: data.orderNumber || "",
        orderQuantity: data.orderQuantity || "",
        // engineRecordArry: data.maintenanceRecord
        //   ? this.formatMaintenanceRecords(
        //       JSON.parse(data.maintenanceRecord).engineRecordArry || []
        //     )
        //   : [],
        // transmissionRecordArry: data.maintenanceRecord
        //   ? this.formatMaintenanceRecords(
        //       JSON.parse(data.maintenanceRecord).transmissionRecordArry || []
        //     )
        //   : [],
        maintenanceRecord: data.maintenanceRecord,
        submit: data.status === 3 ? true : false,
        faultVideo: data.faultVideo ?? 1,
        faultVideoFiles: this.getFileInfo(data.faultVideoFiles),
        faultCode: data.faultCode ?? 1,
        faultCodeRemark: data.faultCodeRemark || "",
        faultCodeFiles: this.getFileInfo(data.faultCodeFiles),
        otherInstructions: data.otherInstructions ?? 1,
        otherRemark: data.otherRemark || "",
        otherFiles: this.getFileInfo(data.otherFiles),
      };
    },
    // 添加故障车vin码
    handleAdd() {
      this.$loading.hide();
      this.form.vinCheckRespList.unshift({});
      this.tabRowIndex = 0;
      this.tabColumnIndex = 0;
      this.$nextTick(() => {
        document.getElementById("inputRef").focus();
      });
    },
    // 删除故障车vin码
    handleDelete({ index, id }) {
      this.form.delList.push({ id: id });
      this.form.vinCheckRespList.splice(index, 1);
      this.getVinRelevantInfo();
    },
    // 批量导入故障车vin码
    handleImport() {
      this.$refs.importModelDialog.init("批量导入");
    },
    // 导入成功列表
    getList(data) {
      if (data.length > 0) {
        data.map((item, index) => {
          // if (
          //   item.messageZh == "成功" &&
          //   item.carModel != null &&
          //   item.carModel != undefined &&
          //   item.carModel != ""
          // ) {
          //   this.form.carModel = item.carModel;
          // }
          data[index].showOrderNumInput =
            !item.orderNum && item.messageZh === "成功";
        });
      }
      // this.form.vinCheckRespList = [...this.form.vinCheckRespList, ...data];
      var allVinList = [...this.form.vinCheckRespList, ...data];
      this.form.vinCheckRespList = allVinList.filter(
        (item, index, arr) =>
          arr.findIndex((obj) => obj.vin === item.vin) === index
      );
      this.getVinRelevantInfo();
    },
    // 把角标赋值给行和列
    getRowColumn({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 单元格点击编辑数据
    tabClick(row, column, cell, event) {
      if (column.property === "vin") {
        this.tabRowIndex = row.index;
        this.tabColumnIndex = column.index;
        this.$nextTick(() => {
          document.getElementById("inputRef").focus();
        });
      }
    },
    async inputBlurNew() {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        vin: this.form.vinCheckRespList[this.tabRowIndex].vin,
        account: this.form.customerAccountNum,
      };
      const res = await getECPDataByVIN(params);
      if (res.data) {
        console.log(res.data);
      }
    },
    // 失去光标
    async inputBlur() {
      setTimeout(async () => {
        try {
          const res = await checkModelApi({
            data: {
              vinCheckRespList: [
                {
                  vin: this.form.vinCheckRespList[this.tabRowIndex].vin,
                },
              ],
            },
          });
          delete res.data[0].id;
          this.$set(this.form.vinCheckRespList, this.tabRowIndex, {
            ...this.form.vinCheckRespList[this.tabRowIndex],
            ...res.data[0],
            showOrderNumInput:
              !res.data[0].orderNum && res.data[0].messageZh === "成功",
          });
        } catch (error) {}
        this.form.vinCheckRespList = this.form.vinCheckRespList.filter(
          (item, index, arr) =>
            arr.findIndex((obj) => obj.vin === item.vin) === index
        );
        this.tabRowIndex = "";
        this.tabColumnIndex = "";
        this.getVinRelevantInfo();
      });
    },
    // 输入VIN码
    handleInput() {
      document.getElementById("inputRef").blur(); // 取消焦点
    },
    // 获取vin列表
    async getVinList() {
      if (this.form.vinCheckRespList.length !== 0) {
        const res = await checkModelApi({
          data: {
            vinCheckRespList: this.form.vinCheckRespList,
          },
        });
        this.form.vinCheckRespList = res.data;
      }
    },
    async getVinRelevantInfo() {
      var vinList = this.form.vinCheckRespList;
      if (vinList.length > 0) {
        // 车型
        this.getModelData(vinList);
        this.form.badCarTotal = vinList.length;
        // 订单号
        this.getOrderData(vinList);
        // 订单车辆数量
        if (this.form.orderNum) {
          const res = await getVehicleAmountByOrderNumber(this.form.orderNum);
          if (res.status == 0) {
            this.form.carTotal = res.data || "0";
          } else {
            this.form.carTotal = this.form.carTotal || "0";
          }
        }
      } else {
        this.form.carModel = "";
        this.form.orderNum = "";
        this.form.carTotal = "0";
        this.form.badCarTotal = "0";
      }
    },
    getModelData(vinList) {
      var modelList = [
        ...new Set(vinList.map((item) => item.carModel).filter(Boolean)),
      ].join(",");
      if (modelList) {
        this.form.carModel = modelList;
      } else {
        this.form.carModel = this.form.carModel;
      }
      // var modelData = modelList ? modelList.split(",") : [];
      // var modelValue = this.form.carModel ? this.form.carModel.split(",") : [];
      // this.form.carModel = [...new Set([...modelData, ...modelValue])].join(",");
    },
    getOrderData(vinList) {
      var orderList = [
        ...new Set(vinList.map((item) => item.orderNum).filter(Boolean)),
      ].join(",");
      if (orderList) {
        this.form.orderNum = orderList;
      } else {
        this.form.orderNum = this.form.orderNum;
      }
    },
    orderInputBlur() {
      var vinList = this.form.vinCheckRespList;
      this.getOrderData(vinList);
    },
    // // 格式化保养记录数据
    // formatMaintenanceRecords(records) {
    //   if (Array.isArray(records)) {
    //     // 如果是新格式的数组对象
    //     return records.map((record) => ({
    //       time: record.time || "",
    //       mileage: record.mileage || "",
    //       content: record.content || "",
    //       photos: record.photos || [],
    //     }));
    //   } else {
    //     // 如果是旧格式的图片数组，转换为新格式
    //     return records
    //       ? [{ time: "", mileage: "", content: "", photos: records }]
    //       : [];
    //   }
    // },
    // 获取疑似/祸首件名称
    handlePartSearch() {
      this.getCheckPartInfo(this);
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        try {
          const submitData = this.getFeedbackDetail();
          let res = {};
          if (submitData.questionId) {
            res = await preProblemEditApi({ data: submitData });
          } else {
            res = await preProblemAddApi({ data: submitData });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success("提交成功");
            this.$emit("success", res.data);
          } else {
            this.$DonMessage.error(res.message);
          }
        } catch (error) {
          console.error(error);
        }
      });
    },
  },
  mounted() {
    this.getTypeList();
  },
};
</script>
